import Card from '@hid-galaxy-ui/galaxy-react/components/Card';
import React from 'react';
import styles from './AccountCreationSuccess.module.scss';
import cx from 'classnames';
import { Iconography, Link, Typography } from '@hid-galaxy-ui/galaxy-react';
import { TypographyVariantEnum } from '@hid-galaxy-ui/galaxy-react/components/Typography/typographyEnum';
import { getTranslation } from '../../../../utils/functions';
import { useHistory } from 'react-router-dom';
import { isBolognaEnv } from '../../../../utils/common';

interface AccountCreationSuccessProps {
  onContinue?: () => void;
}

const AccountCreationSuccess: React.FC<AccountCreationSuccessProps> = () => {
  const history = useHistory();

  const handleGoBack = () => {
    history.push('/');
  };

  return (
    <Card>
      <>
        <div className={styles.imgWrapper}>
          <img
            src="assets/success_icon.svg"
            alt="Success"
            className="successIconStyles"
          />
        </div>
        <div className="hid-spacing__mt-06 m-t-24 hid-flex hid-flex-column hid-flex-ai-center text-wrap-balanced">
          <Typography
            variant={TypographyVariantEnum.H2}
            className="hid-spacing__mb-05"
          >
            {getTranslation('ACCOUNT_CREATION_SUCCESS1')}
          </Typography>

          {isBolognaEnv() && (
            <Typography
              variant={TypographyVariantEnum.BodyLongMarketing}
              className="hid-spacing__mb-07"
            >
              {getTranslation('ACCOUNT_CREATION_SUCCESS2')}
            </Typography>
          )}
        </div>

        {/* <div className="hid-flex hid-flex-jc-center hid-spacing__my-07">
          <Link
            onClick={() => {
              handleGoBack();
            }}
          >
            <Iconography icon="angleLeft" /> &nbsp;
            {`${getTranslation('BACK')}`}
          </Link>
        </div> */}
      </>
    </Card>
  );
};

export default AccountCreationSuccess;
